import * as React from 'react'

import { classList } from 'react-classlist-helper'

import * as Icons from '~/client/src/shared/components/Icons'
import { getAttachmentFileType } from '~/client/src/shared/components/WorkflowCard/fileAttachmentHelpers'
import FileType from '~/client/src/shared/enums/FileType'

interface IProps {
  fileName: string
  className: string
  separator: string
}

const AttachmentFileIcon: React.FC<IProps> = ({
  fileName,
  className,
  separator,
}) => {
  let IconComponent: (props: any) => JSX.Element = () => null
  switch (getAttachmentFileType(fileName, separator)) {
    case FileType.Word:
      IconComponent = Icons.FileWord
      break
    case FileType.Excel:
      IconComponent = Icons.FileExcel
      break
    case FileType.PowerPoint:
      IconComponent = Icons.FilePowerpoint
      break
    case FileType.Pdf:
      IconComponent = Icons.FilePdf
      break
    case FileType.Image:
      IconComponent = Icons.FileImage
      break
    case FileType.Video:
      IconComponent = Icons.FileVideo
      break
    default:
      IconComponent = Icons.FileImage
  }

  return (
    <IconComponent
      className={classList({
        'text-grey-light no-grow': true,
        [className]: true,
      })}
    />
  )
}

export default AttachmentFileIcon
